<template>
  <div class="redline_container">
    <div class="redline_content_block">
        <div class="redline_content_in">
            <p class="content_text"><span style="color: red;font-weight: 700;">红线清单</span>是每位员工必须遵守的组织纪律，是不能触碰的行为高压线，<span style="font-weight: 700;">触犯红线清单人员，将至少受到记过及以上处分</span>；造成重要影响的，应给予降级及以上处分；造成重大影响的，应给予撤职及以上处分；造成特别重大影响的，一律辞退；未构成犯罪，但已严重违反红线清单的，一律辞退；涉嫌犯罪的，辞退并报请集团决策，移送司法。</p>
            <p class="content_text_other">第一条：违背诚信</p>
            <p class="content_text_other">第二条：侵占公司财物</p>
            <p class="content_text_other">第三条：利用工作之便，谋取私利</p>
            <p class="content_text_other">第四条：恶意危害公司信息安全</p>
            <p class="content_text_other">第五条：制度与政策执行，阳奉阴违</p>
            <p class="content_text_other">第六条：其他行为</p>

            <p class="content_text_title">第一条：违背诚信</p>
            <span class="content_show_text">包括但不限于以下行为：</span>
            <span class="content_row_text">1.为了自身及小团队利益，通过虚构业务或恶意篡改、伪造、毁匿账表或证据等方式，人为调节绩效数据；</span>
            <span class="content_row_text">2.虚假入库、以次充好、应验收未验收或敷衍了事；</span>
            <span class="content_row_text">3.虚假领用原料、辅料、零备件等存货；</span>
            <span class="content_row_text">4.虚假降本、虚构生产订单、虚假投料、虚报工时、虚假研发的；</span>
            <span class="content_row_text">5.隐瞒、伪造、变造过往工作履历，在晋升、评优、加薪方面谋取优势的；</span>
            <span class="content_row_text">6.散播或协助传播不利于公司的谣言或言论的；</span>
            <span class="content_row_text">7.代理商、供应商、客户的各类考核、考评、评审过程中弄虚作假的；</span>
            <span class="content_row_text">8.员工在上班时间开展打麻将或其他带有赌博性质活动；</span>
            <span class="content_row_text">9.监督与管理者，接受被监督与被管理者吃请送礼的；</span>
            <span class="content_row_text">10.虚报考勤、代打卡等方式骗取薪酬与奖励的；</span>
            <span class="content_row_text">11.未如实申报利益冲突或帮助第三方掩饰隐瞒利益冲突的；</span>
            <span class="content_row_text">12.提供虚假身份信息、学历/学位、资质信息，骗取入职资格的；</span>
            <span class="content_row_text">13.各类考试、组织氛围调查、关键岗测评等人力资源评估工作中弄虚作假；</span>
            <span class="content_row_text">14.瞒报、虚报盘亏数据的；</span>
            <span class="content_row_text">15.为逃避责任或替他人逃避责任，隐匿、篡改、虚构业务记录的；</span>
            <span class="content_row_text">16.采取不正当拉拢、收买调查人员，毁灭证据、串供、建立“攻守同盟”等方式蓄意阻挠调查工作的。</span>

            <p class="content_text_title">第二条：侵占公司财物</p>
            <span class="content_show_text">包括但不限于以下行为：</span>
            <span class="content_row_text">1.挪用、转移、截留、侵占公司货款、资金的；</span>
            <span class="content_row_text">2.监守自盗、偷梁换柱、将公司资产据为己有、变卖私吞的；</span>
            <span class="content_row_text">3.虚构业务报账、超标准报销费用、私人费用以公务名义报销的；</span>
            <span class="content_row_text">4.为谋取私利，私自转租、抵押、变卖、报废公司资产的；</span>
            <span class="content_row_text">5.私自将工作中的发明专利、著作权据为己有的；</span>
            <span class="content_row_text">6.私自下载大量核心数据资料，无法说明合理用途的；</span>
            <span class="content_row_text">7.为了自身及小团队利益，套取费用，私设小金库。</span>

            <p class="content_text_title">第三条：利用工作之便，谋取私利</p>
            <span class="content_show_text">包括但不限于以下行为：</span>
            <span class="content_row_text">1.以现金、股份、借款、贷款等任何形式索取或收受业务方的回扣或返点、手续费等不正当利益的；</span>
            <span class="content_row_text">2.私自与业务方开展打麻将等带有赌博形式的娱乐活动的；</span>
            <span class="content_row_text">3.指导或协助供应商围串标或制定排他性条款帮助供应商中标的；</span>
            <span class="content_row_text">4.收受直接或间接下级、平级以及公司外部有利益关系的单位或个人赠送的礼金、礼品（价值超100元的）；</span>
            <span class="content_row_text">5.私设公司，并通过与公司发生业务往来，输送利益的；</span>
            <span class="content_row_text">6.销售倒卖非三一配件的；</span>
            <span class="content_row_text">7.私自以公司名义为外部单位进行担保的（含代理商）；</span>
            <span class="content_row_text">8.窃取、泄露技术资料、营销政策、客户信息、代理商信息、供应商信息、财务信息等商业机密，谋取私利的；</span>
            <span class="content_row_text">9.私自散播公司内幕消息，买卖或指导他人买卖股票的；</span>
            <span class="content_row_text">10.伪造公章或未经授权使用公章签署文件的；</span>
            <span class="content_row_text">11.为在自身及所属单位权限范围内审核审批，对项目或报销事项进行拆分，逃避上级单位审批的；</span>
            <span class="content_row_text">12.利用职务影响，为关系人在职务晋升、商业合作等方面谋取利益的；</span>
            <span class="content_row_text">13.利用职务便利，操控工资奖金回流，进行二次分配或侵占的。</span>

            <p class="content_text_title">第四条：恶意危害公司信息安全</p>
            <span class="content_show_text">包括但不限于以下行为：</span>
            <span class="content_row_text">1.对公司网络和信息系统进行黑客攻击等非法操作的；</span>
            <span class="content_row_text">2.在公司内编写、搜集、传播病毒与黑客软件的；</span>
            <span class="content_row_text">3.私自绕过公司信息安全管控策略，进行文件流转的；</span>
            <span class="content_row_text">4.出借、共享他人的域账号及各信息系统账号的；</span>
            <span class="content_row_text">5.私自给自己或其他用户分配系统权限、查看或下载系统中涉密信息的；</span>
            <span class="content_row_text">6.对公司网络和信息系统进行黑客攻击/端口扫描/窃取密码/嗅探网络/解锁机等非法操作的；</span>
            <span class="content_row_text">7.未经审批，流转任何形式的公司涉密信息至集团外部，包括但不限于USB拷贝/邮件/微信等方式的；</span>
            <span class="content_row_text">8.使用私人手机/相机/录音等设备对公司涉密信息进行记录的；</span>
            <span class="content_row_text">9.频繁在办公电脑上从事与工作无关的事项的；</span>
            <span class="content_row_text">10.未经授权的情况下打印受控资料的。</span>

            <p class="content_text_title">第五条：制度与政策执行，阳奉阴违</p>
            <span class="content_show_text">包括但不限于以下行为：</span>
            <span class="content_row_text">1.拒绝执行公司决策，或擅自改变决策内容的；</span>
            <span class="content_row_text">2.违反经营决策十律管理制度的；</span>
            <span class="content_row_text">3.以明显不合理的理由，规避商务集采；</span>
            <span class="content_row_text">4.以明显不合理的理由，规避商务考察或认证的；</span>
            <span class="content_row_text">5.集团三令五申的重点工作，蓄意拖延或应付了事的。</span>

            <p class="content_text_title">第六条：其他行为</p>
            <span class="content_show_text">其他认定为严重失职、渎职或严重干扰公司经营活动的行为。</span>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name: '',
    data() {
        return {

        }
    },

    created(){
        document.title = '红线清单'
    },

    methods: {

    }
}
</script>

<style scoped lang='less'>
    .redline_container{
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        background-color: #f2f2f2;
    }
    .redline_content_block{
        width: 100%;
        position: absolute;
        left: 0;
        top: 10px;
        bottom: 0;
        background-color: white;
        padding: 10px;
        box-sizing: border-box;
        overflow-y: scroll;
    }
    .redline_content_in{
        width: 100%;
        height: auto;
        border: 4px solid red;
        box-sizing: border-box;
        padding: 10px;
    }
    .content_text{
        font-size: 16px;
        color: #333;
        text-align: justify;
        text-indent:2em;
        line-height: 28px;
    }
    .content_text_other{
        font-size: 16px;
        color: #333;
        text-align: left;
        font-weight: 700;
    }
    .content_text_title{
        font-size: 16px;
        color: #333;
        text-align: center;
        font-weight: 700;
        margin-top: 30px;
    }
    .content_show_text{
        display: block;
        font-size: 16px;
        color: #333;
        text-align: left;
    }
    .content_row_text{
        display: block;
        font-size: 16px;
        color: #333;
        text-align: justify;
        margin-top: 10px;
        line-height: 24px;
    }
</style>
